import { generatePath, useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DUPLICATE_PLAYLIST_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../../constants/Navigation';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const DuplicatePlaylistButton = ({
  playlistId,
  use,
  style
}) => {
  const location = useLocation();
  const newLocation = Object.assign({}, location, {
    pathname: `${generatePath(PLAYLIST_URL_FRAGMENT, {
      playlistId
    })}${DUPLICATE_PLAYLIST_URL_FRAGMENT}`,
    state: {
      from: location
    }
  });
  const handleClick = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'duplicate-playlist-click',
      playlistId
    });
  };
  return /*#__PURE__*/_jsx(UIRouterButton, {
    onClick: handleClick,
    style: style,
    to: newLocation,
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlists.duplicatePlaylist"
    })
  });
};